import type { EventGroupArtist as GQLItem } from '../../generated/api.graphql';

import * as Artist from '../Artist/Artist';
import { take } from '../../util';

export type EventGroupArtist = {
  artistId: number;
  eventGroupId: number;
  artist?: Artist.Artist;
  offerSheetId?: number;
};

export const fromGql = (item: GQLItem): EventGroupArtist => ({
  ...take<EventGroupArtist>(item, 'artistId', 'eventGroupId', 'offerSheetId'),
  artist: item.artist ? Artist.fromGql(item.artist) : undefined,
});

export const fromGqlCollection = (items: GQLItem[]): EventGroupArtist[] => items.map(item => fromGql(item));
